export const cssForWord = {

  data: `
      body {
        font-family: Helvetica, sans-serif;
        font-size: 12px;
      }
    
      #rtable {
        border-collapse: collapse;
      }

      #reportHead {
        color: white;
        background-color: black;
        font-family: Helvetica, sans-serif;
        font-size: 12px;
      }
      
      .reportCells {
        padding-top: 12px;
        padding-bottom: 12px;
        padding-left: 12px;
        padding-right: 12px;
        border-bottom: solid 2px #000;
        white-space: pre-line;
      }
    
      #accessibilityCol {
        text-align: center;
        padding-left: 0.5em;
      }
    
      #rtable table tbody td:last-child,
      #rtable table tbody th:last-child {
        border-right: none;
        border-radius: 0 25px 0 0;
      }
      
      #capabilityCol {
        text-align: center;
      }

      #urlCol {
        width: 20%;
      }     
        
      .code {
        font-family: 'CodeFont';
        font-size: 12px;
        display: inline;
      }

      @page {
          size: 11in 8in;
          mso-page-orientation: landscape;
          border: solid 1px red;
          font-size: 12px;
        }
      }
      
      @page Section1 {
      }
      
      div.Section1 {
        page: Section1;
      }`
}

export const cssForPDF = {

  data: `
    @font-face {
      font-family: "BodyFont";
      src: url("../Roboto-Regular.ttf");
    }

    @font-face {
      font-family: "HeaderFont";
      src: url("../LexendDeca-Medium.ttf");
    }

    @font-face {
      font-family: "CodeFont";
      src: url("../RobotoMono-Regular.ttf");
    }

    body {
      font-family: 'BodyFont';
      font-size: 12px;
      line-height: 19px;
      height: 100%;
      margin: 0;
      padding: 0;
      white-space: pre-wrap;
    }

    #topReportInfo { 
      font-family: 'HeaderFont';
      page-break-after: always;
    }

    #topReportInfo p {
      color: #6A6A6A;
      font-size: 16px;
    }

    #logo {
      margin-top: 100px;
    }

    #logo img {
      max-width: 131px;
    }

    .page-header { 
      font-size: 43px;
    }

    figcaption h2 p b,
    .link-list h2 {
      font-family: 'HeaderFont';
      font-size: 18px;
    }

    .link-list {
      page-break-after: always;
    }

    .link-list p,
    .link-list ul {
      font-family: 'BodyFont';
      line-height: 19px;
    }

    th {
      text-align: center;
      word-wrap: break-word;
      max-width: 200px;
    }

    thead {
      display: table-header-group;
    }

    td {
      max-width: 200px;
      word-break: break-all;
      overflow-wrap: break-word;
      word-wrap: break-word;
      white-space: normal;
    }

    #urlRow {
      word-wrap: break-word;
      vertical-align: text-top;
    }
    
    #rtable {
      border-collapse: collapse;
      width: 100%;
    }

    table {
      page-break-after: always;
      table-layout: fixed;
      width: 100%;
    }

    table:last-child {
      page-break-after: avoid;
    }

    #reportHead {
      color: white;
      background-color: black;
      font-family: 'BodyFont';
      font-size: 12px;
    }
    
    .reportCells {
      padding-top: 12px;
      padding-bottom: 12px;
      padding-left: 12px;
      padding-right: 12px;
      border-bottom: solid 2px #000;
      white-space: pre-line;
      vertical-align: text-top;
    }

    .reportCells p {
      margin-top: 0;
      margin-bottom: -0.5em;
    }

    .guidance ul, 
    .guidance ol {
      margin-top: 0;
      margin-bottom: 0;
      padding-top: 0;
      padding-bottom: 0;
    }

    .guidance ul li,
    .guidance ol li {
      margin-top: -0.9em;
      margin-bottom: 0;
    }

    .guidance ul li:first-child,
    .guidance ol li:first-child {
      margin-top: -1.5em;
      margin-bottom: 0;
    }

    #guidanceCol {
      text-align: center;
      padding-left: 0.5em;
      width: 38%;
    }
  
    #rtable table tbody td:last-child,
    #rtable table tbody th:last-child {
      border-right: none;
      border-radius: 0 25px 0 0;
    }
    
    #capabilityCol {
      text-align: center;
      width: 10%;
    }

    .code-inline {
      font-family: 'CodeFont';
      font-size: 12px;
      display: inline;
      color: #333333;
      background-color: #f4f4f4;
      border: 1px solid #DDDDDD;
      border-radius: 3px;
      padding: 0 0.35em;
      white-space: normal;
      -webkit-box-decoration-break: clone;
      box-decoration-break: clone;
    }

    .code-block {
      display: block;
      font-family: 'CodeFont';
      font-size: 12px;
      line-height: 1.5;
      color: #333;
      background-color: #f4f4f4;
      border: 1px solid #ddd;
      border-radius: 4px;
      padding: 0.5em 0.75em;
      margin: 0.4em 0;
      white-space: pre-wrap !important;
      word-break: break-word;
      overflow-wrap: break-word;
      overflow: visible;
    }

    @page {
        size: 11in 8in;
        font-size: 12px;
        thead {
            display: table-header-group;
        }
      }
    }
    `
}